export const OPTION_VALUES = {
  YES: 'yes',
  NOT_YET: 'not_yet',
  NO: 'no',
}
